export const SearchResultsSkeleton = () => {
  return (
    <>
      {Array(5)
        .fill(1)
        .map((num, i) => (
          <div
            data-test="search-results-skeleton"
            className="py-[7px] pl-4 pr-2"
            key={i}
          >
            <div className="flex justify-between">
              <div className="h-4 w-[203px] rounded bg-chorus-gray-100"></div>
              <div className="h-4 w-[52px] rounded bg-chorus-gray-100"></div>
            </div>
            <div className="mt-1 flex justify-between">
              <div className="h-4 w-[119px] rounded bg-chorus-gray-100"></div>
              <div className="h-4 w-[119px] rounded bg-chorus-gray-100"></div>
            </div>
          </div>
        ))}
    </>
  );
};
